<script setup lang="ts">
defineProps<{
  id: string
  options: readonly { value: string, label: string }[]
}>()

const model = defineModel<{ value: string, label: string }>({ required: true })
</script>

<template>
  <FormComboboxWithBadge
    :id="id"
    v-model="model"
    label="Sorter etter"
    :multiple="false"
    intent="filled"
    content-align="end"
    :badge="false"
    :options="options"
    :option-label="option => `${option.label}`"
    class="w-fit"
  />
</template>
